import { useCallback } from "react";
import { useDispatch } from 'react-redux';
import ReactPixel from 'react-facebook-pixel';
import { useNavigate } from "../vendor/router-ROUTER_TARGET";

import { setStoreRoute, updateStoreHistory, resetTabBar } from "../actions/index";
import { resetNCState } from "../components/library/nav-control/redux/actions/index";

//  Store Route Management
const useRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goTo = useCallback( to => {

    // NAV-CONTROL (MODULE)
    dispatch(resetNCState());

    // BREADCRUMB
    navigate(to);
    dispatch(updateStoreHistory(to));

    // Save Last Visited Page
    localStorage.setItem('LVP', to);

    // TABBAR
    dispatch(resetTabBar());

    //PIXEL FACEBOOK
    ReactPixel.pageView();
    ReactPixel.track(`ViewContent`, { url: to });

  }, [dispatch, navigate])

  const getLastLocation = () => {
    return window.location.pathname; // live read: called later from the store, not during render
  }

  const store = { goTo, getLastLocation };
  setTimeout(() => { dispatch(setStoreRoute(store)) }, 100);
  return null;
};

export default useRoute;
